/** @file GENERATED by pnpm gen; do not edit. */
import { tool as e0 } from './tools/createBone/tool';
import { tool as e1 } from './tools/editMesh/tool';
import { tool as e2 } from './tools/grabItem/tool';
import { tool as e3 } from './tools/ik/tool';
import { tool as e4 } from './tools/paintWeights/tool';
import { tool as e5 } from './tools/rotate/tool';
import { tool as e6 } from './tools/scale/tool';
import { tool as e7 } from './tools/select/tool';
import { tool as e8 } from './tools/translate/tool';
export const TOOLS = [e0, e1, e2, e3, e4, e5, e6, e7, e8] as const;
